import { notContainsOnlySpaces } from "../../../utils";

export const validationADBDistrictInput = (fieldValues, temp) => {
  if ("districtName" in fieldValues) {
    temp.districtName = notContainsOnlySpaces(fieldValues.districtName)
      ? ""
      : "This field is required.";
  }

  if ("districtCode" in fieldValues) {
    if (fieldValues.districtCode === null) {
      temp.districtCode = "This field is required.";
    } else if (fieldValues.districtCode === "") {
      temp.districtCode = "This field is required.";
    } else {
      temp.districtCode = "";
    }
    if (isNaN(fieldValues.districtCode)) {
      temp.districtCode = "field must be a number";
    }

    if ("provinceId" in fieldValues) {
      temp.provinceId =
        fieldValues.provinceId.length !== 0 ? "" : "This field is required.";
    }
  }

  return temp;
};
